import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './tp.css';

const Privacy = () => {
  return (
    <>
      <Navbar />
      <main className="legal-container">
        <div className="container">
          <h1>Privacy Policy</h1>

          <p>
            This Privacy Policy explains how information about you is collected, used, and disclosed by Smartvizs Private Limited ("SmartvizX").
            It applies when you use our website at <a href="http://smartvizx.com" target="_blank" rel="noreferrer">http://smartvizx.com</a>,
            mobile sites or apps linked to this policy, or otherwise interact with us.
          </p>
          <p>
            We may update this policy periodically. We encourage you to review it regularly to stay informed about our practices.
          </p>

          <h2>1. Collection of Information</h2>
          <p>
            We collect information you provide directly (e.g., name, email) when submitting forms or contacting us.
          </p>

          <h2>2. Information Collected Automatically</h2>
          <p>
            We may collect details like browser type, IP address, pages visited, device model, and operating system.
          </p>
          <p>
            Cookies and tracking technologies may be used to analyze usage and improve your experience.
          </p>

          <h2>3. Use of Information</h2>
          <ul>
            <li>Maintain and improve our Websites</li>
            <li>Send alerts, updates, or support messages</li>
            <li>Respond to user queries or feedback</li>
            <li>Communicate about SmartvizX products, events, or promotions</li>
            <li>Monitor and personalize your experience on the site</li>
            <li>Fulfill any other purpose for which the information was collected</li>
          </ul>
          <p>
            Your data may be stored or processed in India and other jurisdictions in accordance with Indian laws.
          </p>

          <h2>4. Sharing of Information</h2>
          <p>We may share your information:</p>
          <ul>
            <li>With service providers who help us operate our business</li>
            <li>When required by law, regulation, or legal process</li>
            <li>To protect SmartvizX’s rights or safety</li>
            <li>In business transfers like mergers or acquisitions</li>
            <li>With your consent or direction</li>
            <li>As aggregated or anonymized data</li>
          </ul>

          <h2>5. Social Sharing Features</h2>
          <p>
            Integrated tools like the Facebook “Like” button may collect data per their own policies.
            Please refer to the respective platforms for privacy settings and controls.
          </p>

          <h2>6. Security</h2>
          <p>
            We use reasonable safeguards to protect your data against loss, misuse, and unauthorized access or disclosure.
          </p>

          <h2>7. Your Choices</h2>
          <h3>Cookies</h3>
          <p>
            You can set your browser to reject cookies, but this may limit some functionality of our site.
          </p>

          <h3>Promotional Communications</h3>
          <p>
            You can opt out of promotional emails by following instructions in the emails. Transactional messages will still be sent.
          </p>

          <h2>8. Contact Us</h2>
          <p>
            For questions about this Privacy Policy, please contact us at <a href="mailto:info@smartvizx.com">info@smartvizx.com</a>.
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Privacy;
